import 'css-chunksrc/client/pages/projectPage/exportsPage/timesheetByTaskReport/sort/styles.scss';export default {
  "sort": "_sort_1tr8u_1",
  "label": "_label_1tr8u_9",
  "input": "_input_1tr8u_15",
  "placeholder": "_placeholder_1tr8u_31",
  "icon": "_icon_1tr8u_39",
  "listRoot": "_listRoot_1tr8u_47",
  "list": "_list_1tr8u_47",
  "item": "_item_1tr8u_63",
  "option": "_option_1tr8u_76",
  "selected": "_selected_1tr8u_83",
  "opened": "_opened_1tr8u_96"
};